document.addEventListener("DOMContentLoaded", () => {
    // Initialize the forms module

    // swiper init
    const sliderElement = document.querySelector('.blaze-slider');
    const sliderInstance = new BlazeSlider(sliderElement, {
        all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            loop: true,
            enableAutoplay: true,
            autoplayInterval: 5000,
            slideGap: '0px',
            stopAutoplayOnInteraction: false,
            transitionDuration: 800,
            transitionTimingFunction: "ease-in-out"
        }
    });

    // dynamic counters
    const totalSlides = document.querySelectorAll('.blaze-slide').length;
    updateCounters(0, totalSlides);

    sliderInstance.onSlide((pageIndex, firstSlideIndex, lastSlideIndex) => {
        const totalSlides = document.querySelectorAll('.blaze-slide').length;
        updateCounters(firstSlideIndex, totalSlides);
    });

    function updateCounters(firstSlideIndex, totalSlides) {
        const currentIndex = firstSlideIndex + 1;
        const nextIndex = currentIndex < totalSlides ? currentIndex + 1 : 1;

        document.querySelector('.counter-back').textContent = currentIndex < 10 ? `0${currentIndex}` : currentIndex;
        document.querySelector('.counter-next').textContent = nextIndex < 10 ? `0${nextIndex}` : nextIndex;
    }

    // dynamic progressbar
    startProgressBar();

    sliderInstance.onSlide(() => {
        resetProgressBar();
    });

    function startProgressBar() {
        const progressBar = document.querySelector('.progress-bar');
        progressBar.style.transition = 'width 5s linear';
        progressBar.style.width = '100%';
    }

    function resetProgressBar() {
        const progressBar = document.querySelector('.progress-bar');
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';

        setTimeout(startProgressBar, 10);
    }

    // input type date
    toggleInputPlaceholders();

    function toggleInputPlaceholders() {
        let inputs = document.querySelectorAll(".form-control[type='date'], .form-control[type='time']");
        
        if (!inputs) return;
    
        function checkInputValue() {
            inputs.forEach(input => {
                if (input.value && input.value.trim() !== "") {
                    input.setAttribute("data-filled", "true");
                } else {
                    input.setAttribute("data-filled", "false");
                }
            })
        }
    
        inputs.forEach(input => {
            input.addEventListener("input", checkInputValue);
        })
        
        checkInputValue();
    }  
    
    
    const phoneInput = document.querySelector("#event-whatsapp");
    if (phoneInput) {
        phoneInput.addEventListener("input", function (e) {
            let value = e.target.value.replace(/\D/g, ""); // Remove tudo que não for número

            if (value.length > 11) {
                value = value.slice(0, 11); // Limita a 11 dígitos
            }

            // Formata o número de telefone corretamente
            if (value.length > 2) {
                value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
            }
            if (value.length > 10) {
                value = `${value.slice(0, 10)}-${value.slice(10)}`;
            }

            e.target.value = value; // Atualiza o valor do input com a máscara
        });
    }

    // =============================
    // Máscara CPF
    // =============================
    const cpfInput = document.getElementById("event-cpf");
    if (cpfInput) {
        cpfInput.addEventListener("input", () => {
            let value = cpfInput.value.replace(/\D/g, '');
            value = value.slice(0, 11);

            if (value.length >= 10) {
                cpfInput.value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
            } else if (value.length >= 7) {
                cpfInput.value = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
            } else if (value.length >= 4) {
                cpfInput.value = value.replace(/(\d{3})(\d{1,3})/, "$1.$2");
            } else {
                cpfInput.value = value;
            }
        });
    }
})